import { render, staticRenderFns } from "./data-list.vue?vue&type=template&id=99fb061e&scoped=true"
import script from "./data-list.vue?vue&type=script&lang=js"
export * from "./data-list.vue?vue&type=script&lang=js"
import style0 from "./data-list.vue?vue&type=style&index=0&id=99fb061e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99fb061e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99fb061e')) {
      api.createRecord('99fb061e', component.options)
    } else {
      api.reload('99fb061e', component.options)
    }
    module.hot.accept("./data-list.vue?vue&type=template&id=99fb061e&scoped=true", function () {
      api.rerender('99fb061e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/correspondence/batch/data-list.vue"
export default component.exports